var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:Object.assign({}, _vm.displayClasses,
    {
        'text-secondary': _vm.isDisabled,
        'strike': _vm.isStrike,
        'font-weight-bold': _vm.isBold,
    })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }